__turbopack_context__.v({
  "pillLabel": "styles-module__FYqFua__pillLabel",
  "pillsGroup": "styles-module__FYqFua__pillsGroup",
  "radioGroup": "styles-module__FYqFua__radioGroup",
  "radioLabel": "styles-module__FYqFua__radioLabel",
});
